import {useSuspenseQuery} from '@tanstack/react-query';
import {categorySchema, prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {categoryKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getCategories = async (params: QueryParams = {}) => {
  const res = await api.get(`categories`, {
    searchParams: prepareSearchParams(params),
  });
  const data = await res.json();
  const pagination = extractPagination(res);
  return [categorySchema.array().parse(data), pagination] as const;
};

export const useCategories = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: categoryKeys.list(params),
    queryFn: () => getCategories(params),
  });
};
export const useCategoriesLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getCategories;
type QueryParams = Parameters<typeof categoryKeys.list>[0];
